// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"0faa1fd5b1252b9c","5285":"62078e5b34d417bb"}[chunkId] + ".css";
};